import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import { GeoveraThemeProvider } from './theme/ThemeContext';
import './index.css';
import App from './App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <GeoveraThemeProvider>
        <App />
      </GeoveraThemeProvider>
    </Provider>
  </StrictMode>
);
